import { useEffect, useRef } from "react";

const GoogleMap = ({ markers = [], height = "400px", minHeight = "253px" }) => {
    const mapRef = useRef(null);
    const mapInstance = useRef(null);

    useEffect(() => {
        if (!markers.length) return;

        const position = markers[0].latlng;
        const location = { lat: position[0], lng: position[1] };

        const loadMap = () => {
            if (mapInstance.current) return;

            mapInstance.current = new window.google.maps.Map(mapRef.current, {
                zoom: 10,
                center: location,
                styles: [
                    {
                        featureType: "landscape",
                        elementType: "geometry",
                        stylers: [{ color: "#dfe6ed" }]
                    },
                    {
                        featureType: "water",
                        elementType: "geometry",
                        stylers: [{ color: "#aadaff" }]
                    }
                ],
                mapTypeControl: false,     // Map / Satellite
                fullscreenControl: false,  // Fullscreen
                streetViewControl: false,  // Pegman
                zoomControl: false,        // + -
                scaleControl: false,
                rotateControl: false
            });

            new window.google.maps.Marker({
                position: location,
                map: mapInstance.current
            });
        };

        // Google Maps already loaded
        if (window.google && window.google.maps) {
            loadMap();
        } else {
            // Load script once
            const existingScript = document.getElementById("google-maps");

            if (!existingScript) {
                const script = document.createElement("script");
                script.id = "google-maps";
                script.src =
                    "https://maps.googleapis.com/maps/api/js?key=AIzaSyCXLaGIDZ5poKhVKHwf6oXXrGmpAVlUsfU";
                script.async = true;
                script.onload = loadMap;
                document.head.appendChild(script);
            } else {
                existingScript.onload = loadMap;
            }
        }
    }, [markers]);

    return (

        <div ref={mapRef} style={{ height, width: "100%", height: '100%' }} />

    );
};

export default GoogleMap;
